<template>
  <div class="">
    <homepage-main-section />
    <homepage-agency-section />
    <homepage-new-ideas />
    <homepage-customize-qr />
    <homepage-analytic-section />
    <partials-benifit-widget />
    <partials-reviewer-widget />
    <homepage-ower-system />
  </div>
</template>
<script lang="ts" setup>
import moment from "moment";
import DataLocale from "~~/config/interface/DataLocale";

const seoheader = new DataLocale([
  {
    locale: "en",
    title: "Free Online QR Code Generator - Dynamic QR Code ",
    description:
      "QR Gateway offers a comprehensive range of QR code services, including code generation, design customization, and performance tracking. Create visually appealing codes directly from images, audio, and video files, perfect for promoting your business, introducing products, or even enhancing your educational and training materials. ",
    keywords:
      "qr code generator online, wifi qr code generator, facebook qr code, qr code android, paypal qr code, qrcode online, qr code editor, qr code video, qr image, qrcode generator online, safe qr code generator, best qr code, qr code marketing, qr code advertising, branding qr codes, event marketing qr codes, qr code marketing ideas, dynamic qr code, free dynamic qr code generator, free dynamic qr code, best free dynamic qr code generator",
  },
  {
    locale: "vi",
    title: "Trình tạo mã QR trực tuyến miễn phí - Mã QR động",
    description:
      "QR Gateway cung cấp một loạt dịch vụ mã QR toàn diện, bao gồm tạo mã, tùy chỉnh thiết kế và theo dõi hiệu suất. Tạo mã QR trực tiếp từ hình ảnh, tệp âm thanh và video, hoàn hảo để quảng bá doanh nghiệp, giới thiệu sản phẩm hoặc cải tiến tài liệu giáo dục và đào tạo của bạn.",
    keywords:
      "trình tạo mã qr trực tuyến, trình tạo mã qr wifi, mã qr facebook, mã qr android, mã qr paypal, qr code online, trình chỉnh sửa mã qr, mã qr video, ảnh mã qr, trình tạo mã qr động trực tuyến miễn phí, trình tạo mã qr động an toàn, trình tạo mã qr động tốt nhất, qr code marketing, qr code advertising, branding qr codes, event marketing qr codes, qr code marketing ideas, dynamic qr code, free dynamic qr code generator, free dynamic qr code, best free dynamic qr code generator",
  },

  {
    locale: "ja",
    title: "無料オンラインQRコードジェネレーター-ダイナミックQRコード",
    description:
      "QR Gatewayは、コードの生成、デザインのカスタマイズ、パフォーマンスの追跡を含む包括的なQRコードサービスを提供しています。画像、音声、ビデオファイルから直接魅力的なコードを作成し、ビジネスの宣伝、製品の紹介、教育・トレーニング資料の向上に最適です。",
    keywords:
      "オンラインqrコードジェネレーター、wifi qrコードジェネレーター、Facebook qrコード、qrコードandroid、paypal qrコード、qrcode online、qrコードエディター、qrコードビデオ、qrイメージ、qrcode generator online、安全なqrコードジェネレーター、最高のqrコード、qrコードマーケティング、qrコード広告、ブランディングqrコード、イベントマーケティングqrコード、qrコードマーケティングのアイデア、ダイナミックqrコード、無料のダイナミックqrコードジェネレーター、無料のダイナミックqrコード、最高の無料のダイナミックqrコードジェネレーター",
  },
  {
    locale: "zh",
    title: "免费在线QR码生成器-动态QR码",
    description:
      "QR Gateway 提供全面的 QR 码服务，包括码的生成、设计定制和性能跟踪。可以直接从图像、音频和视频文件中创建外观精美的码，非常适合推广业务、介绍产品，甚至增强您的教育和培训材料。",
    keywords:
      "qr码生成器在线，wifi qr码生成器，facebook qr码，qr码安卓，paypal qr码，在线二维码，qr码编辑器，qr码视频，qr图片，qrcode生成器在线，安全qr码生成器，最佳qr码，qr码营销，qr码广告，品牌qr码，活动营销qr码，qr码营销创意，动态qr码，免费动态qr码生成器，免费动态qr码，最佳免费动态qr码生成器",
  },
  {
    locale: "nl",
    title: "Gratis online QR-codegenerator - Dynamische QR-code",
    description:
      "QR Gateway biedt een uitgebreid scala aan QR-code diensten, inclusief codegeneratie, ontwerp-aanpassing en prestatietracking. Maak visueel aantrekkelijke codes rechtstreeks vanuit afbeeldingen, audio- en videobestanden, perfect voor het promoten van uw bedrijf, het introduceren van producten of zelfs het verbeteren van uw educatieve en trainingsmateriaal.",
    keywords:
      "qr code generator online, wifi qr code generator, facebook qr code, qr code android, paypal qr code, qrcode online, qr code editor, qr code video, qr image, qrcode generator online, safe qr code generator, best qr code, qr code marketing, qr code advertising, branding qr codes, event marketing qr codes, qr code marketing ideas, dynamic qr code, free dynamic qr code generator, free dynamic qr code, best free dynamic qr code generator",
  },
  {
    locale: "pt",
    title: "Gerador de código QR online gratuito - Código QR dinâmico",
    description:
      "O QR Gateway oferece uma ampla gama de serviços de código QR, incluindo geração de código, personalização de design e rastreamento de desempenho. Crie códigos visualmente atraentes diretamente de imagens, arquivos de áudio e vídeo, perfeitos para promover seu negócio, apresentar produtos ou até mesmo melhorar seus materiais educacionais e de treinamento.",
    keywords:
      "gerador de código QR online, gerador de código QR wifi, código QR do Facebook, código QR do Android, código QR do PayPal, qrcode online, editor de código QR, vídeo de código QR, imagem de código QR, gerador de código QR online seguro, melhor código QR, marketing de código QR, publicidade de código QR, códigos QR de marca, códigos QR de marketing de eventos, ideias de marketing de código QR, código QR dinâmico, gerador de código QR dinâmico gratuito, código QR dinâmico gratuito, melhor gerador de código QR dinâmico gratuito",
  },
  {
    locale: "es",
    title: "Generador de códigos QR en línea gratis - Código QR dinámico",
    description:
      "QR Gateway ofrece una amplia gama de servicios de códigos QR, que incluyen la generación de códigos, la personalización de diseño y el seguimiento de rendimiento. Cree códigos visualmente atractivos directamente desde imágenes, archivos de audio y video, perfectos para promocionar su negocio, presentar productos o incluso mejorar sus materiales educativos y de capacitación.",
    keywords:
      "generador de códigos QR en línea, generador de códigos QR wifi, código QR de Facebook, código QR de Android, código QR de PayPal, qrcode en línea, editor de código QR, video de código QR, imagen de código QR, generador de códigos QR en línea seguro, mejor código QR, marketing de código QR, publicidad de código QR, códigos QR de marca, códigos QR de marketing de eventos, ideas de marketing de código QR, código QR dinámico, generador de códigos QR dinámico gratuito, código QR dinámico gratuito, mejor generador de códigos QR dinámico gratuito",
  },
  {
    locale: "de",
    title: "Kostenloser Online-QR-Code-Generator - Dynamischer QR-Code",
    description:
      "QR Gateway bietet ein umfassendes Angebot an QR-Code-Services, einschließlich Code-Generierung, Design-Anpassung und Leistungsverfolgung. Erstellen Sie visuell ansprechende Codes direkt aus Bildern, Audio- und Videodateien, perfekt zur Förderung Ihres Unternehmens, zur Vorstellung von Produkten oder sogar zur Verbesserung Ihrer Bildungs- und Schulungsmaterialien.",
    keywords:
      "QR-Code-Generator online, Wifi QR-Code-Generator, Facebook QR-Code, QR-Code Android, Paypal QR-Code, Qrcode online, QR-Code-Editor, QR-Code-Video, QR-Bild, Qrcode-Generator online, sicherer QR-Code-Generator, bester QR-Code, QR-Code-Marketing, QR-Code-Werbung, Branding-QR-Codes, Eventmarketing-QR-Codes, QR-Code-Marketing-Ideen, dynamischer QR-Code, kostenloser dynamischer QR-Code-Generator, kostenloser dynamischer QR-Code, bester kostenloser dynamischer QR-Code-Generator",
  },
  {
    locale: "fr",
    title: "Générateur de code QR en ligne gratuit - Code QR dynamique",
    description:
      "QR Gateway propose une gamme complète de services QR code, comprenant la génération de codes, la personnalisation de design et le suivi de performances. Créez des codes visuellement attrayants directement à partir d'images, de fichiers audio et vidéo, parfaits pour promouvoir votre entreprise, présenter des produits ou même améliorer vos supports pédagogiques et de formation.",
    keywords:
      "générateur de code QR en ligne, générateur de code QR wifi, code QR Facebook, code QR Android, code QR Paypal, Qrcode en ligne, éditeur de code QR, vidéo QR code, image QR, générateur de code Qrcode en ligne, générateur de code QR sécurisé, meilleur code QR, marketing QR code, publicité QR code, codes QR de branding, marketing événementiel QR codes, idées de marketing QR code, code QR dynamique, générateur de code QR dynamique gratuit, meilleur générateur de code QR dynamique gratuit",
  },
  {
    locale: "it",
    title: "Generatore di codici QR online gratuito - Codice QR dinamico",
    description:
      "QR Gateway offre una vasta gamma di servizi QR code, tra cui la generazione di codici, la personalizzazione del design e il monitoraggio delle prestazioni. Crea codici visivamente accattivanti direttamente dalle immagini, dai file audio e video, perfetti per promuovere la tua attività, presentare i tuoi prodotti o migliorare i tuoi materiali didattici e di formazione.",
    keywords:
      "generatore di codice QR online, generatore di codice QR wifi, codice QR Facebook, codice QR Android, codice QR Paypal, Qrcode online, editor di codice QR, codice QR video, immagine QR, generatore di codice Qrcode online, generatore di codice QR sicuro, miglior codice QR, marketing QR code, pubblicità QR code, codici QR di branding, marketing evento codici QR, idee di marketing QR code, codice QR dinamico, generatore di codice QR dinamico gratuito, miglior generatore di codice QR dinamico gratuito",
  },
]);

const datajd = useDataJd();
const meta = useMeta();

const i18nHead = useLocaleHead({
  addSeoAttributes: {
    canonicalQueries: ["/"],
  },
});
const meta_tags = meta.metaTag({
  title: seoheader.data.title,
  description: seoheader.data.description,
  url: datajd.currentURL(),
  image: datajd.assets("/images/og/qrgateway.jpg"),
});
useHead({
  title: seoheader.data.title,
  meta: [
    { name: "description", content: seoheader.data.description },
    { name: "keywords", content: seoheader.data.keywords },
    ...(i18nHead.value.meta || []),
    ...meta_tags,
  ],
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs!.lang,
  },
  link: [...(i18nHead.value.link || [])],
});
useSchemaOrg([
  defineWebPage({
    name: seoheader.data.title,
    datePublished: moment("2023-05-03").toISOString(),
    dateModified: moment().toISOString(),
    description: seoheader.data.description,
    inLanguage: datajd.inLanguages(true),
    url: datajd.currentURL(),
    image: datajd.assets("/images/og/qrgateway.jpg"),
    "@type": "AboutPage",
  }),
  defineBreadcrumb({
    itemListElement: [
      {
        item: {
          "@id": datajd.currentHost(),
          name: "Home",
        },
      },
      { item:{name: useI18n().t("features"), "@id": datajd.currentHost()+"/features"} },
    ],
  }),
]);
</script>
